export const API_ROUTES = {
  // Auth routes
  AUTH: {
    CSRF_COOKIE: "/csrf-cookie",
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
  },
  // Password Reset routes (NUEVO)
  PASSWORD: {
    FORGOT: "/password/forgot",
    VERIFY_TOKEN: "/password/verify-token",
    RESET: "/password/reset",
  },
  // Profile routes
  PROFILE: {
    BASE: "/me",
    UPDATE: "/me", // PUT /me
    CHANGE_PASSWORD: "/me/password", // PUT /me/password
    REGENERATE_TOKEN: "/me/token", // POST /me/token
  },
  // Users management routes (NUEVO)
  USERS: {
    BASE: "/users", // GET (activos), POST (crear)
    ALL: "/users/all", // GET (todos activos e inactivos)
    TRASHED: "/users/trashed", // GET (eliminados soft)
    DETAIL: (id: number) => `/users/${id}`, // PUT, DELETE
    RESTORE: (id: number) => `/users/${id}/restore`, // POST
    FORCE: (id: number) => `/users/${id}/force`, // POST (hard delete)
    UPDATE_ROLE: (id: number) => `/users/${id}/role`,
    CHANGE_PASSWORD: (id: number) => `/users/${id}/password`, // PUT
  },
  // 👇 NUEVA SECCIÓN PARA REGISTRATIONS
  REGISTRATIONS: {
    BASE: "/registrations", // GET - Lista todos los registrados
    DETAIL: (id: number) => `/registrations/${id}`, // GET - Detalle de un registrado
    WITH_HISTORY: (id: number) => `/registrations/${id}/with-history`, // Historial de un registrado
    APPROVE: (id: number | string) => `/registrations/${id}/verificar-aprobar`,
    OBSERVE: (id: number | string) => `/registrations/${id}/observar`,
    REJECT: (id: number | string) => `/registrations/${id}/rechazar`,
    FORCE_DELETE: (id: number) => `/registrations/${id}/force`,
    REGISTER_PAYMENT: (id: number | string) =>
      `/registrations/${id}/registrar-pago`,
    EXPORT_HISTORY: (id: number, format: "pdf" | "excel") =>
      `/registrations/${id}/history/export/${format}`,
  },
  // 👇 NUEVA SECCIÓN PARA CLIENTS
  CLIENTS: {
    BASE: "/clients",
    ALL: "/clients",
    ACTIVE: "/clients/active",
    TRASHED: "/clients/trashed",
    DETAIL: (id: number) => `/clients/${id}`,
    WITH_HISTORY: (id: number) => `/clients/${id}/with-history`,
    EXPORT_HISTORY: (id: number, format: "pdf" | "excel") =>
      `/clients/${id}/history/export/${format}`,
    CREATE: "/clients",
    UPDATE: (id: number) => `/clients/${id}`,
    DELETE: (id: number) => `/clients/${id}`,
    PAGOS: (id: number) => `/clients/${id}/pagos`,
    GESTIONAR_ACCESO: (id: number) => `/clients/${id}/gestionar-acceso`,
    CAMBIAR_ESTADO: (id: number) => `/clients/${id}/cambiar-estado-cliente`,
  },

  // Subscriptions routes
  SUBSCRIPTIONS: {
    BASE: "/subscriptions",
    DETAIL: (id: number) => `/subscriptions/${id}`,
    STATS: "/subscriptions/estadisticas",
    ACTIVE: "/subscriptions/active",
    TRASHED: "/subscriptions/trashed",
    BY_CLIENT: (clientId: number) => `/subscriptions/client/${clientId}`,
    CREATE: "/subscriptions",
    UPDATE: (id: number) => `/subscriptions/${id}`,
    CANCEL: (id: number) => `/subscriptions/${id}/cancel`,
    RENEW: (id: number) => `/subscriptions/${id}/renew`,
    TOGGLE_CURRENT: (id: number) => `/subscriptions/${id}/toggle-current`,
    MOVEMENTS: (id: number) => `/subscriptions/${id}/movements`,
    PERIODS: (id: number) => `/subscriptions/${id}/periods`,
    RESTORE: (id: number) => `/subscriptions/${id}/restore`,
    FORCE_DELETE: (id: number) => `/subscriptions/${id}/force`,
    // ✅ NUEVAS RUTAS
    CHANGE_PLAN: (id: number) => `/subscriptions/${id}/change-plan`,
    CHANGE_CYCLE: (id: number) => `/subscriptions/${id}/change-cycle`,
    RENEW_MANUAL: (id: number) => `/subscriptions/${id}/renew-manual`,
    SUSPEND: (id: number) => `/subscriptions/${id}/suspend`,
    REACTIVATE: (id: number) => `/subscriptions/${id}/reactivate`,
    MODULES: (id: number) => `/subscriptions/${id}/modules`,
    TOGGLE_MODULE: (id: number) => `/subscriptions/${id}/toggle-module`,
  },

  OSE_CREDENTIALS: {
    CLIENT: (id: number) => `/clients/${id}/ose-credentials`,
  },

  // ✅ ONBOARDING ROUTES
  ONBOARDING: {
    BASE: "/clients/onboarding", // GET - Listar clientes en onboarding
    STATS: "/onboarding/stats", // GET - Estadísticas
    DETAIL: (id: number) => `/clients/${id}`, // GET - Detalle de cliente
    CREATE_DATABASE: (id: number) => `/clients/${id}/crear-bd`, // POST - Iniciar creación de plataforma
    VERIFY_PLATFORM: (id: number) => `/onboarding/${id}/verify-platform`, // POST - Verificar plataforma
    COMPLETE: (id: number) => `/onboarding/${id}/complete`, // POST - Completar onboarding
    OBSERVE: (id: number) => `/onboarding/${id}/observe`, // POST - Observar
    HISTORY: (id: number) => `/clients/${id}/with-history`, // GET - Historial
    VALIDAR_PLATAFORMA: (id: number) => `/onboarding/${id}/validar-plataforma`, // ← AGREGAR
  },

  // Agrega esto dentro del objeto API_ROUTES
  DASHBOARD: {
    OVERVIEW: "/dashboard/overview",
    RESUMEN: "/dashboard/resumen",
    COBRANZA: "/dashboard/cobranza",
    ESTADO_PLANES: "/dashboard/estado-planes",
    ALERTAS_VENCIMIENTO: "/dashboard/alertas-vencimiento",
    LIMITES: "/dashboard/limites",
  },

  // ========== ANALÍTICA ROUTES ==========
  ANALITICA: {
    KPIS: "/analitica/kpis",
    EVOLUCION_CARTERA: "/analitica/evolucion-cartera",
    DISTRIBUCION_PLANES: "/analitica/distribucion-planes",
    RESUMEN_SUSCRIPCIONES: "/analitica/resumen-suscripciones",
    RESUMEN_COBRANZA: "/analitica/resumen-cobranza",
    RESUMEN_ONBOARDING: "/analitica/resumen-onboarding",
    RESUMEN_OPERACIONES: "/analitica/resumen-operaciones",
    RESUMEN_CONSUMO: "/analitica/resumen-consumo",
    TOP_MOVIMIENTOS: "/analitica/top-movimientos",
  },

  // ========== CARTERA ROUTES ==========
  CARTERA: {
    KPIS: "/cartera/kpis",
    FUERZAS_CRECIMIENTO: "/cartera/fuerzas-crecimiento",
    VARIACION_PERIODO: "/cartera/variacion-periodo",
    EVOLUCION_CARTERA: "/cartera/evolucion-cartera",
    COMPOSICION_CLIENTES: "/cartera/composicion-clientes",
    CLIENTES_OBSERVADOS: "/cartera/clientes-observados",
    MOTIVOS_BAJA: "/cartera/motivos-baja",
    RESUMEN_ABANDONO: "/cartera/resumen-abandono",
    HISTORICO_CRECIMIENTO: "/cartera/historico-crecimiento",
    VARIACION_HISTORICA: "/cartera/variacion-historica",
  },

  // ========== SUSCRIPCIONES ANALÍTICA (NUEVO) ==========
  SUSCRIPCIONES_ANALITICA: {
    KPIS: "/suscripciones/kpis",
    ESTADO: "/suscripciones/estado",
    ALERTAS_VIGENCIA: "/suscripciones/alertas-vigencia",
    DISTRIBUCION_PLAN: "/suscripciones/distribucion-plan",
    DISTRIBUCION_CICLO: "/suscripciones/distribucion-ciclo",
    COMBINACION_PLAN_CICLO: "/suscripciones/combinacion-plan-ciclo",
    MOVIMIENTOS_POR_TIPO: "/suscripciones/movimientos-por-tipo",
    CAMBIOS_PLAN: "/suscripciones/cambios-plan",
    TENDENCIA: "/suscripciones/tendencia",
    VARIACION_COMERCIAL: "/suscripciones/variacion-comercial",
  },

  // ========== COBRANZA ==========
  COBRANZA: {
    KPIS: "/cobranza/kpis",
    ESTADO: "/cobranza/estado",
    POR_PLAN: "/cobranza/por-plan",
    POR_CICLO: "/cobranza/por-ciclo",
    METODO_PAGO: "/cobranza/metodo-pago",
    PAGOS_POR_CONFIRMAR: "/cobranza/pagos-por-confirmar",
    TENDENCIA: "/cobranza/tendencia",
    VARIACION: "/cobranza/variacion",
  },

  // ========== ONBOARDING ANALÍTICA ==========
  ONBOARDING_ANALITICA: {
    KPIS: "/onboarding-analitica/kpis",
    EMBUDO: "/onboarding-analitica/embudo",
    TIEMPOS_ETAPA: "/onboarding-analitica/tiempos-etapa",
    CUELLOS_BOTELLA: "/onboarding-analitica/cuellos-botella",
    TENDENCIA: "/onboarding-analitica/tendencia",
    VARIACION: "/onboarding-analitica/variacion",
  },

  // ========== OPERACIONES ==========
  OPERACIONES: {
    KPIS: "/operaciones/kpis",
    ESTADO_CASOS: "/operaciones/estado-casos",
    PRIORIDAD_CASOS: "/operaciones/prioridad-casos",
    CASOS_POR_TIPO: "/operaciones/casos-por-tipo",
    TIEMPOS_OPERATIVOS: "/operaciones/tiempos-operativos",
    CUMPLIMIENTO_ATENCION: "/operaciones/cumplimiento-atencion",
    CASOS_POR_ORIGEN: "/operaciones/casos-por-origen",
    PLANES_INCIDENCIAS: "/operaciones/planes-incidencias",
    TENDENCIA: "/operaciones/tendencia",
    VARIACION: "/operaciones/variacion",
  },

  // ========== CONSUMO Y CAPACIDAD ==========
  CONSUMO: {
    KPIS: "/consumo/kpis",
    USO_POR_RECURSO: "/consumo/uso-por-recurso",
    CLIENTES_POR_NIVEL: "/consumo/clientes-por-nivel",
    COMPARATIVO_PLANES: "/consumo/comparativo-planes",
    CLIENTES_CERCA_LIMITE: "/consumo/clientes-cerca-limite",
    CLIENTES_POCO_USO: "/consumo/clientes-poco-uso",
    TENDENCIA: "/consumo/tendencia",
    VARIACION: "/consumo/variacion",
  },

  // ========== CONFIGURACIÓN ==========
  CONFIG: {
    // Comercial
    PLANS: "/plans",
    BILLING_CYCLES: "/billing-cycles",
    PAYMENT_METHODS: "/payment-methods",

    // Global
    PLATFORM_CONFIG: "/platform-config",
    SUPPORT_CONFIG: "/support-config",
    NOTIFICATIONS: "/notifications-config",

    // Seguridad
    SESSIONS_ACTIVE: "/sessions/active",
    SESSIONS_TERMINATE: (id: string) => `/sessions/${id}`,
    COMMERCIAL_RULES: "/commercial-rules",
  },

  // ✅ ROLES ROUTES
  ROLES: {
    BASE: "/roles",
    DETAIL: (id: number) => `/roles/${id}`,
    PERMISSIONS: (id: number) => `/roles/${id}/permissions`,
  },

  // ✅ PERMISSIONS ROUTES
  PERMISSIONS: {
    BASE: "/permissions",
    MODULES: "/permissions/modules",
    DETAIL: (id: number) => `/permissions/${id}`,
    LIST_ACTIVE: "/permissions/active/list", // ✅ NUEVO
  },

  // ✅ PLANES ROUTES (si usas API_ROUTES.PLANS.BASE)
  PLANS: {
    BASE: "/plans",
    ACTIVE: "/plans/active",
    ALL: "/plans/all",
    DETAIL: (id: number) => `/plans/${id}`,
  },

  // ========== MÓDULOS DEL SISTEMA ==========
  SYSTEM_MODULES: {
    BASE: "/system-modules",
    ACTIVE: "/system-modules/active",
    DETAIL: (id: number) => `/system-modules/${id}`,
    RESTORE: (id: number) => `/system-modules/${id}/restore`,
    FORCE: (id: number) => `/system-modules/${id}/force`,
  },

  SUPPORT: {
    // Correos
    EMAILS: "/support-emails",
    // Teléfonos
    PHONES: "/support-phones",
    // WhatsApps
    WHATSAPPS: "/support-whatsapps",
    // Horario de atención
    BUSINESS_HOURS: "/support-business-hours",
  },

  // ========== COMUNICADOS GLOBALES ==========
  GLOBAL_ANNOUNCEMENTS: {
    BASE: "/global-announcements",
    ACTIVE: "/global-announcements/active",
    RESTORE: (id: number) => `/global-announcements/${id}/restore`,
    FORCE_DELETE: (id: number) => `/global-announcements/${id}/force`,
  },

  // ========== BANDEJA DE NOTIFICACIONES DEL SISTEMA ==========
  SYSTEM_NOTIFICATIONS: {
    BASE: "/notifications",
    MARK_AS_READ: (id: string) => `/notifications/${id}/read`,
    MARK_ALL_AS_READ: "/notifications/read-all",
    DELETE: (id: string) => `/notifications/${id}`,
  },

  // ========== CONFIGURACIÓN DE NOTIFICACIONES ==========
  NOTIFICATION_CONFIG: {
    BASE: "/notifications-config",
    ACTIVE: "/notifications-config/active",
    DETAIL: (id: string) => `/notifications-config/${id}`,
  },

  // ========== APLICATIVOS ADMINISTRATIVOS ==========
  ADMIN_APPLICATIONS: {
    BASE: "/configuracion-global/aplicativos",
    DETAIL: (id: number) => `/configuracion-global/aplicativos/${id}`,
    DOWNLOAD: (id: number) => `/configuracion-global/aplicativos/${id}/download`,
  },

  // ========== CONSULTA RUC/DNI ==========
  CONSULTA_RUC_DNI: {
    BASE: "/consulta-ruc-dni",
    TEST: "/consulta-ruc-dni/test",
    VERIFY: "/consulta-ruc-dni/verify",
  },

  // ========== FEATURES (Funcionalidades) ==========
  FEATURES: {
    BASE: "/features",
    BY_PLAN: "/features/by-plan",
    DETAIL: (id: number) => `/features/${id}`,
  },

  // ========== PLAN FEATURES (Asignación de funcionalidades a planes) ==========
  PLAN_FEATURES: {
    BY_PLAN: (planId: number) => `/plans/${planId}/features`,
    ASSIGN_BULK: (planId: number) => `/plans/${planId}/features/bulk`,
    REMOVE: (planId: number, featureId: number) =>
      `/plans/${planId}/features/${featureId}`,
  },

  // ========== ESTADO DEL SISTEMA ==========
  SYSTEM_STATUS: {
    OVERVIEW: "/system-status/overview",
    LATEST: "/system-status/latest",
    CPU_METRICS: "/system-status/metrics/cpu",
    RAM_METRICS: "/system-status/metrics/ram",
  },

  // ========== LOGS DEL SISTEMA ==========
  SYSTEM_LOGS: {
    BASE: "/system-logs",
    STATS: "/system-logs/stats",
    DETAIL: (id: string) => `/system-logs/${id}`,
    UPDATE_STATUS: (id: string) => `/system-logs/${id}/status`,
  },
} as const;
